import Typography from "../typography/Typography";
import styles from "./discount.module.scss";

interface iDiscountProps {
  promoCodeTitle?: string;
  promoCodeDescription?: string;
}

function Discount({ promoCodeTitle = "", promoCodeDescription = "" }: iDiscountProps): JSX.Element {
  return (
    <div className={styles.main}>
      <Typography weight={500} className={styles.promoDesc}>
        🎉 {promoCodeDescription}
      </Typography>
    </div>
  );
}

export default Discount;
